import styled from 'styled-components';
import { Flex, FlexProps, Menu, MenuDropdownProps, MenuItemProps } from '@mantine/core';

export const SummaryWrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 100%;

	& > div {
		flex: 1;
		display: flex;
		flex-direction: column;

		& > div:last-child {
			flex: 1;
			min-height: 0;
		}
	}
`;

export const StyledCreateMipDropdown = styled(Menu.Dropdown)<MenuDropdownProps>`
	width: max-content;
	border-radius: 0.5rem;
	padding: 0.5rem;
	box-shadow: 0px 16px 32px 0px #dcdfe0;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[0]};
`;

export const StyledCreateMipItem = styled(Menu.Item)<MenuItemProps & { onClick?: () => void }>`
	&& {
		padding: 0.5rem;
		border-radius: 0.25rem;
	}

	&:hover {
		background-color: ${({ theme }) => theme.v3.colors.gray[0]};
	}
`;

export const MipSectionWrapper = styled(Flex)<FlexProps & { $mipCount: number }>`
	flex: 1;
	display: flex;
	flex-direction: column;

	${({ $mipCount }) =>
		$mipCount <= 6 &&
		`
		min-height: 0;
	`}

	& > div {
		${({ $mipCount }) =>
			$mipCount <= 6
				? `
			flex: 1;
			display: flex;
			flex-direction: column;
		`
				: `
			flex: initial;
		`}

		& > div:last-child {
			${({ $mipCount }) =>
				$mipCount <= 6 &&
				`
				flex: 1;
				min-height: 0;
			`}
		}
	}
`;
